"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextInput = exports.useTextInput = exports.enhanceTextInput = exports.InputMode = void 0;
const react_1 = __importStar(require("react"));
const TextInput_pc_1 = require("./TextInput.pc");
const react_number_format_1 = __importDefault(require("react-number-format"));
const lodash_1 = require("lodash");
var InputMode;
(function (InputMode) {
    InputMode["DOLLAR"] = "dollar";
    InputMode["PHONE_NUMBER"] = "phone_number";
    InputMode["MONTH_YEAR_DATE"] = "month_year_date";
    InputMode["TEXT"] = "text";
    InputMode["PASSWORD"] = "password";
    InputMode["TEXT_AREA"] = "text_area";
})(InputMode = exports.InputMode || (exports.InputMode = {}));
const isNumericMode = (mode) => {
    return (mode === InputMode.DOLLAR ||
        mode === InputMode.PHONE_NUMBER ||
        mode === InputMode.MONTH_YEAR_DATE);
};
const castValue = (value, mode) => {
    if (isNumericMode(mode)) {
        return Number(value);
    }
    return value;
};
/**
 * Enhances text-input-like components such as input & textarea (Only ones I'm aware of AFAIK) (CC)
 */
function enhanceTextInput(TextInputComponent) {
    return (_a) => {
        var { 'data-testid': testid, value, onValueChange, disabled, inputMode, autoFocus, tabIndex, type = 'text' } = _a, rest = __rest(_a, ['data-testid', "value", "onValueChange", "disabled", "inputMode", "autoFocus", "tabIndex", "type"]);
        const { onChange } = (0, exports.useTextInput)({
            onValueChange,
            inputMode,
            value,
        });
        return (react_1.default.createElement(TextInputComponent, Object.assign({}, rest, { tabIndex: tabIndex, disabled: disabled, autoFocus: autoFocus, testid: testid, onChange: onChange, defaultValue: value, type: type })));
    };
}
exports.enhanceTextInput = enhanceTextInput;
const useTextInput = ({ value, onValueChange, format, inputMode = InputMode.TEXT, }) => {
    const [internalValue, setInternalValue] = (0, react_1.useState)(value);
    // sync switch for syncing input value with value passed in
    const [shouldSync, setShouldSync] = (0, react_1.useState)(false);
    const [type, setType] = (0, react_1.useState)(inputMode === InputMode.PASSWORD ? 'password' : 'text');
    // check here to ensure that props.value is the same as internalValue. If not, then
    // we update.
    (0, react_1.useEffect)(() => {
        // if internal value mismatch then sync value with input & set internal value
        if (internalValue !== value) {
            setInternalValue(value);
            setShouldSync(true);
        }
    }, [value]);
    // async turn it off so that value isn't returned in props next time this hook
    // is called
    (0, react_1.useEffect)(() => {
        setShouldSync(false);
    }, [shouldSync]);
    const onChange = (event) => {
        onValueChange2(event.target.value);
    };
    const onValueChange2 = (value) => {
        const actualValue = castValue(value, inputMode);
        setInternalValue(actualValue);
        if (onValueChange) {
            onValueChange(actualValue);
        }
    };
    const onIconClick = () => {
        if (inputMode === InputMode.PASSWORD) {
            if (type === 'text') {
                setType('password');
            }
            else {
                setType('text');
            }
        }
    };
    const NumberInputComponent = (0, react_1.useCallback)((props) => {
        const onChange = ({ floatValue }) => {
            onValueChange2(floatValue);
        };
        if (inputMode === InputMode.PHONE_NUMBER) {
            return (react_1.default.createElement(react_number_format_1.default, Object.assign({}, props, { format: "###-###-####", mask: "_", onChange: lodash_1.noop, onValueChange: onChange })));
        }
        else if (inputMode === InputMode.MONTH_YEAR_DATE) {
            return (react_1.default.createElement(react_number_format_1.default, Object.assign({}, props, { format: "##/####", mask: "_", onChange: lodash_1.noop, onValueChange: onChange })));
        }
        else if (inputMode === InputMode.DOLLAR) {
            return (react_1.default.createElement(react_number_format_1.default, Object.assign({}, props, { prefix: "$", thousandSeparator: true, onChange: lodash_1.noop, onValueChange: onChange, decimalSeparator: false, decimalScale: 0, allowLeadingZeros: false })));
        }
    }, [format, setInternalValue]);
    let tagName = 'input';
    if (inputMode === InputMode.TEXT_AREA) {
        tagName = 'textarea';
    }
    else if (isNumericMode(inputMode)) {
        tagName = NumberInputComponent;
    }
    let props = {
        onChange,
        defaultValue: value,
        onIconClick,
        type,
        tagName,
    };
    // if sync is set then upstream value has changed, so set
    // value here. Note that value should _NOT_ be persistent since it'll
    // lock the input value in its place
    if (shouldSync) {
        props.value = internalValue;
    }
    return props;
};
exports.useTextInput = useTextInput;
const TextInput = (_a) => {
    var { inputMode, onValueChange, value, subtext, 'data-testid': testId, format, prefix, disabled, icon, minimal } = _a, rest = __rest(_a, ["inputMode", "onValueChange", "value", "subtext", 'data-testid', "format", "prefix", "disabled", "icon", "minimal"]);
    const _b = (0, exports.useTextInput)({
        onValueChange,
        inputMode,
        value,
        format,
    }), { type, onIconClick } = _b, restHookProps = __rest(_b, ["type", "onIconClick"]);
    if (inputMode === InputMode.PASSWORD && !disabled) {
        icon =
            type === 'password' ? (react_1.default.createElement(TextInput_pc_1.Eye, { onClick: onIconClick })) : (react_1.default.createElement(TextInput_pc_1.EyeOff, { onClick: onIconClick }));
    }
    return (react_1.default.createElement(TextInput_pc_1.TextInput, Object.assign({ type: type, testid: testId, v3: true, disabled: disabled }, rest, restHookProps, { icon: icon &&
            react_1.default.cloneElement(icon, {
                width: '20px',
                height: '20px',
                className: '-translate-x-1/2 -translate-y-1/2',
            }), minimal: minimal })));
};
exports.TextInput = TextInput;
//# sourceMappingURL=TextInput.js.map